import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://c6e482235b657c704ba0d2d67547ea5f@o849093.ingest.us.sentry.io/4508580506501120",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration()],
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
});